import React, { useEffect, useState } from "react";
import "./Aboutus2.css";
import about01 from "../../assest/About/about-01.jpg";
import about02 from "../../assest/About/about-02.jpg";
import about03 from "../../assest/About/about-03.jpg";

const images = [
  { src: about01, className: "about-image-small" },
  { src: about02, className: "about-image-large" },
  { src: about03, className: "about-image-small" },
];

const AboutUs2 = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 8000);  

    return () => clearInterval(interval);  
  }, []);
 
  return (
    <div className="about-container">
      <div className="about-header">
        <div className="about-text-container">
          <h1 className="about-title">Welcome To Our Company</h1>
          <p className="about-description">
            We are a technology company established in 2013 in Thailand. We have a
            team with over 10 years of experience in the IT industry. Our strategy is to grow our business together with our customers and partners, focusing on cloud-based solutions, enterprise solutions, and IT gadgets.
          </p>
        </div>
        <img
          src={images[currentIndex].src}
          alt="About Us"
          className={images[currentIndex].className}
        />
      </div>

      <div className="about-sections-container">
        <div className="about-section">
          <h2 className="about-subtitle">Cloud-based Solution</h2>
          <p className="about-text">
          is becoming popular and common everyday. Many company has spended a lot of money to the same solution, while those systems have the low utilization, high cost of administration, high cost for maintainance, and need upgrading every 3-5 years. The cloud-based solution allow user to focus only application, so they can spend the money and time with business strategy. We believe that we can provide the key Software As A Service (SAAS) in various application that can support all need in your company.          </p>
        </div>

        <div className="about-section">
          <h2 className="about-subtitle">Enterprise Solution</h2>
          <p className="about-text">
          is being demanded to reduce the TOC every year. We want to help customer reduce the IT budget by introducing Open Source and Intel Standard instead of propritory stack. By using open source and standard hardware allow customer to have standard operation environment which can transform to automation easily and can help customer reduce a lot of budget.          </p>
        </div>

        <div className="about-section">
          <h2 className="about-subtitle">IT Gadget</h2>
          <p className="about-text">
          will be playing the important part of our company in the future. The end point device is shifting from person computer to mobile and tablet. Many company is starting to ask their employee to bring their device to work (BYOD-Bring Your Own Device). This market has a lot of demand from comsumer and it is an attrative hugh market for us. We are selecting the cool staff from around the world for customer to personalized themselves.</p>        </div>
      </div>
     
    </div>
);
};

export default AboutUs2;